export enum ApplyToEnum {
  ApplyToAllSelectedCompanies = 0,
  ApplyToSelectedOnly = 1,
  ApplyToAllCompanies = 2,
  IncorrectApply = -1
}
